import * as React from "react";
import { useEffect, useState } from "react";
import withParams from "routing/withParams";
import { PageHeader, DocumentTitle } from "components/common";
import UsersPageNavigation from "components/users/navigation/UsersPageNavigation";
import DocsHelper from "util/DocsHelper";
import TeamDetails from "../components/team-details/TeamDetails";
import TeamsDomain from "../domainActions/TeamsDomain";
import TeamActionLinks from "../components/navigation/TeamActionLinks";
const PageTitle = ({ name }) => /* @__PURE__ */ React.createElement(React.Fragment, null, "Team Details", " ", name && /* @__PURE__ */ React.createElement(React.Fragment, null, "- ", /* @__PURE__ */ React.createElement("i", null, name)));
const TeamDetailsPage = ({ params }) => {
  const teamId = params == null ? void 0 : params.teamId;
  const [team, setTeam] = useState();
  const name = team == null ? void 0 : team.name;
  useEffect(() => {
    TeamsDomain.load(teamId).then(setTeam);
  }, [teamId]);
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: `Team Details ${name != null ? name : ""}` }, /* @__PURE__ */ React.createElement(UsersPageNavigation, null), /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: /* @__PURE__ */ React.createElement(PageTitle, { name }),
      actions: /* @__PURE__ */ React.createElement(TeamActionLinks, { team }),
      documentationLink: {
        title: "Permissions documentation",
        path: DocsHelper.PAGES.USERS_ROLES
      }
    },
    /* @__PURE__ */ React.createElement("span", null, "Overview of details like settings, assigned users and roles. This page also provides an overview of all entities which are being shared with this team.")
  ), /* @__PURE__ */ React.createElement(TeamDetails, { team }));
};
export default withParams(TeamDetailsPage);
